import React from "react";

import { Stack } from "@mui/material";

import DangerZone from "../components/OrganizationDetails/DangerZone";
import GeneralSettingsCard from "../components/OrganizationDetails/GeneralSettingsCard";
import PlatformIdentityProviderCard from "../components/OrganizationDetails/PlatformIdentityProviderCard";
import OrganizationPageShell from "../components/OrganizationPageShell";

const OrganizationSettingsPage = () => (
  <OrganizationPageShell pageTitle="Settings">
    {(organization, reload) => (
      <Stack spacing={2}>
        <GeneralSettingsCard
          organization={organization}
          onSaved={() => void reload()}
        />
        <PlatformIdentityProviderCard orgAlias={organization.alias} />
        <DangerZone resourceName={organization.alias} />
      </Stack>
    )}
  </OrganizationPageShell>
);

export default OrganizationSettingsPage;
